declare global {
  interface Window {
    Intercom: (...args: unknown[]) => void
  }
}

function intercom(...args: unknown[]) {
  if (typeof window !== "undefined" && window.Intercom) {
    window.Intercom(...args)
  }
}

export function useIntercom() {
  return {
    show: () => intercom("show"),
    hide: () => intercom("hide"),
    showNewMessage: (message?: string) =>
      message ? intercom("showNewMessage", message) : intercom("showNewMessage"),
    trackEvent: (name: string, metadata?: Record<string, unknown>) =>
      intercom("trackEvent", name, metadata),
    trackDeckAnalyzed: (data: { analysisType: string; charCount: number }) =>
      intercom("trackEvent", "deck_analyzed", data),
    update: (data: Record<string, unknown>) => intercom("update", data),
    showSpace: (space: string) => intercom("showSpace", space),
  }
}
